module.exports = __webpack_public_path__ + "static/img/mapboxDark.c24859e.jpg";